// ✅ SubjectTechnologyManager.jsx – komponenta za povezivanje subjecta i tehnologija
import React, { useEffect, useState } from "react";
import axios from "axios";

const SubjectTechnologyManager = () => {
  const [subjects, setSubjects] = useState([]);
  const [technologies, setTechnologies] = useState([]);
  const [selectedSubjectId, setSelectedSubjectId] = useState("");
  const [selectedTechIds, setSelectedTechIds] = useState([]);

  useEffect(() => {
    fetchSubjects();
    fetchTechnologies();
  }, []);

  useEffect(() => {
    if (selectedSubjectId) {
      fetchSubjectTechnologies(selectedSubjectId);
    }
  }, [selectedSubjectId]);

  const fetchSubjects = async () => {
    const res = await axios.get("https://modularobjects.com/checkout/api/subjects");
    setSubjects(res.data);
  };

  const fetchTechnologies = async () => {
    const res = await axios.get("https://modularobjects.com/checkout/api/technologies");
    setTechnologies(res.data);
  };

  const [loading, setLoading] = useState(false);

const fetchSubjectTechnologies = async (subjectId) => {
  setLoading(true);
  try {
    const res = await axios.get(`https://modularobjects.com/checkout/api/subject-technologies/${subjectId}`);
    setSelectedTechIds(res.data.map(t => t.id));
  } catch (err) {
    console.error("Greška pri dohvatanju povezanih tehnologija:", err);
    setSelectedTechIds(res.data.map(t => t.id));
  } finally {
    setLoading(false);
  }
};



  const handleCheckboxChange = (techId) => {
    setSelectedTechIds((prev) =>
      prev.includes(techId) ? prev.filter((id) => id !== techId) : [...prev, techId]
    );
  };

  

  const handleSave = async () => {
    try {
      await axios.post(`https://modularobjects.com/checkout/api/subject-technologies/${selectedSubjectId}`, {
        technologyIds: selectedTechIds
      });
      alert("Veze sa tehnologijama su uspešno sačuvane.");
    } catch (err) {
      console.error("Greška prilikom čuvanja veza:", err);
      alert("Greška pri čuvanju veza.");
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">Povezivanje subjekata i tehnologija</h2>

      <select
        value={selectedSubjectId}
        onChange={(e) => setSelectedSubjectId(e.target.value)}
        className="border rounded p-2 mb-4 w-full"
      >
        <option value="">-- Izaberi subjekt --</option>
        {subjects.map((s) => (
          <option key={s.id} value={s.id}>{s.company_name || s.email}</option>
        ))}
      </select>

      {selectedSubjectId && (
        <div className="space-y-2 mb-4">
          {technologies.map((tech) => (
            <label key={tech.id} className="block">
              <input
                type="checkbox"
                checked={selectedTechIds.includes(tech.id)}
                onChange={() => handleCheckboxChange(tech.id)}
              /> {tech.name}
            </label>
          ))}
        </div>
      )}

      <button
        onClick={handleSave}
        disabled={!selectedSubjectId}
        className="bg-blue-600 text-white px-4 py-2 rounded"
      >
        Sačuvaj povezivanje
      </button>
    </div>
  );
};

export default SubjectTechnologyManager;
